import { Action } from '@ngrx/store';


export const CHOOSE_DOC = 'CHHOSE_DOC';
export const ADD_SOCIETE = 'ADD_SOCIETE';
export const ADD_SIGNATAIRE = 'ADD_SIGNATAIRE';
export const ADD_DOCUMENT = 'ADD_DOCUMENT';
export const INITIALIZE = 'INITIALIZE';
export const LIST_DOCUMENTS = 'LIST_DOCUMENTS';

export const GAMME_SITE = 'GAMME_SITE';
export const MODEL_SITE = 'MODEL_SITE';
export const LISTING_SITE = 'LISTING_SITE';
export const DETAIL_SITE = 'DETAIL_SITE';
export const STRUCTURE_SITE = 'STRUCTURE_SITE';

export class ChooseDocument implements Action{
    readonly type = CHOOSE_DOC;
    constructor(public payload?: any){}
}

export class AddSociete implements Action{
    readonly type = ADD_SOCIETE;

    constructor(public payload: any){}
} 

export class AddSignataire implements Action{
    readonly type = ADD_SIGNATAIRE;
    
    constructor(public payload: any){}
} 

export class AddDocument implements Action{
    readonly type = ADD_DOCUMENT;
    
    constructor(public payload: any){}
} 

export class InitState implements Action{
    readonly type = INITIALIZE;
    
    constructor(){}
} 

export class ListDocuments implements Action{
    readonly type = LIST_DOCUMENTS;
    
    constructor(public payload: any){}
} 

export class GammeSite implements Action{
    readonly type = GAMME_SITE;
    
    constructor(public payload: string){}
} 

export class ModelSite implements Action{
    readonly type = MODEL_SITE;
    
    constructor(public payload: any){}
} 

export class ListingSite implements Action{
    readonly type = LISTING_SITE;
    
    constructor(public payload: any){}
} 

export class DetailSite implements Action{
    readonly type = DETAIL_SITE;
    
    constructor(public payload: any){}
} 

export class StructureSite implements Action{
    readonly type = STRUCTURE_SITE;
    
    constructor(public payload: any){}
} 

export type layoutAction = 
    | ChooseDocument 
    | AddSociete 
    | AddSignataire 
    | AddDocument 
    | InitState 
    | ListDocuments
    | GammeSite
    | ModelSite
    | ListingSite
    | DetailSite
    | StructureSite;


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/common/appstore/actions.ts